const state = {
  navAwards: [
    {
      title: 'judges',
      dec: '2023',
      tabName: 'judges',
      componentName: 'Judges',
      isActive: false,
      isDisplay: true
    },
    {
      title: 'rules',
      dec: 'adman',
      tabName: 'rules',
      componentName: 'Rules',
      isActive: true,
      isDisplay: true
    },
    {
      title: 'categories',
      dec: 'adman',
      tabName: 'categories',
      componentName: 'Categories',
      isActive: false,
      isDisplay: true
    }
  ]
}

const mutations = {
  AWARDS (state, title) {
    state.navAwards.forEach(nav => {
      nav.isActive = false

      if (nav.title === title || nav.tabName === title) {
        nav.isActive = true
      }
    })
  }
}

const actions = {
  awards ({ commit }, title) {
    commit('AWARDS', title)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
